import { all, call, put, takeLatest } from 'redux-saga/effects'
import normalized from 'json-api-normalizer'
import * as actions from './actions'
import * as api from './api'
import { getSortedIds } from 'helpers/jsonAPI'

function* fetchCouponsWorker({ payload }) {
  try {
    const { data } = yield call(api.getCoupons, payload)

    const normalizedData = normalized(data, {
      camelizeKeys: false,
      camelizeTypeValues: false,
    })

    yield put(
      actions.fetchCouponsSuccess({
        ...payload,
        page: payload.page,
        pageCount: data.meta.page_count,
        coupons: normalizedData,
        sortedIds: getSortedIds(data.data),
      })
    )
  } catch (error) {
    console.error(error)
    yield put(actions.fetchCouponsFailure())
  }
}

function* deleteCouponWorker({ payload }) {
  try {
    const { data } = yield call(api.deleteCoupon, payload)
    if (data) {
      yield put(actions.deleteCouponSuccess(payload))
    } else {
      yield put(actions.deleteCouponFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.deleteCouponFailure())
  }
}

function* updateCouponWorker({ payload }) {
  try {
    const { data } = yield call(api.updateCoupon, payload)
    if (data) {
      yield put(actions.updateCouponSuccess(payload))
    } else {
      yield put(actions.updateCouponFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.updateCouponFailure())
  }
}

function* createCouponWorker({ payload }) {
  try {
    const { data } = yield call(api.createCoupon, payload)
    if (data) {
      yield put(actions.createCouponSuccess(payload))
    } else {
      yield put(actions.createCouponFailure())
    }
  } catch (error) {
    console.error(error)
    yield put(actions.createCouponFailure())
  }
}

export default function* () {
  yield all([
    takeLatest(actions.fetchCoupons, fetchCouponsWorker),
    takeLatest(actions.deleteCoupon, deleteCouponWorker),
    takeLatest(actions.createCoupon, createCouponWorker),
    takeLatest(actions.updateCoupon, updateCouponWorker),
  ])
}
